import {FETCH_PROJECTS_BEGIN, FETCH_PROJECTS_FAILURE, FETCH_PROJECTS_SUCCESS, UPDATE_PROJECTS_FILTER} from "../actions/projects";
import {ProjectsState} from "./index";
import {AnyAction} from "redux";
import {updateObject} from "../utils/miscUtils";

const initialState: ProjectsState = {
  items: [],
  filter: ""
};

const projects = (state: ProjectsState = initialState, action: AnyAction) => {
  switch(action.type) {
    case FETCH_PROJECTS_BEGIN:
      return updateObject<ProjectsState>(state, {
        filter: ""
      });
    case FETCH_PROJECTS_SUCCESS:
      return updateObject<ProjectsState>(state, {
        items: action.payload.projects,
        filter: ""
      });
    case FETCH_PROJECTS_FAILURE:
      return updateObject<ProjectsState>(state, {
        filter: ""
      });
    case UPDATE_PROJECTS_FILTER:
      return updateObject<ProjectsState>(state,{
        filter: action.filter
      });
    default:
      return state;
  }
};

export default projects;
